import './App.scss';
import { useState } from 'react';
import { PBCLogo } from './components/generic/logo';
import { ColorBlocks } from './components/generic/colorBlocks';
import { ColorBlocks2 } from './components/generic/colorBlocks2';
import { useSearchParams } from 'react-router-dom';
import React from 'react';

let content = "By allowing us to email you, we can provide you with important information about your account, such as to alert you to a payment due date. Are you sure you want to unsubscribe from emails?";
const currentYear = new Date().getFullYear().toString();

function App() {
  const [state, setState] = useState("")
  const [searchParams, setSearchParams] = useSearchParams();
  const guid = searchParams.get("guid");

  if (state != "")
    content = state

  function accept(){
    fetch(window.location.protocol + "//" + window.location.host + '/unsubscribe', {
      method: 'POST',
      body: JSON.stringify({
        guid: guid
      })
    })
    .then(
      (response) => response.text()
    )
    .then(
      (text) => {console.log(text); setState(text)}
    )
    .catch((err) => {
      console.log(err.message);
    });
    return setState(content);
  }

  return (
    <div className="App">
      <div className="Logo">
        <PBCLogo/>
      </div>
      <div className="App-Main">
          <ColorBlocks className="ColorBlocks"/>
          <ColorBlocks2 className="ColorBlocks2"/>
          <div className="Controls">
          <p>
            {content}
          </p>
          {
            state == "" && <div>
              <button className="btn-pro btn-pro-primary" onClick={accept}>
                Accept
              </button>
            </div>
          }
        </div>
      </div>
      <div className="Footer">
        <p id="footer-copyright" className="FooterText">
          © {currentYear} First PREMIER Bank and PREMIER Bankcard. All rights reserved. Member FDIC.
        </p>
      </div>
    </div>
  );
}

export default App;
